// extracted by mini-css-extract-plugin
export default {"byline":"styles---byline---dPxpU"};